import { render, staticRenderFns } from "./image-capture.vue?vue&type=template&id=bd98a7a4&scoped=true&"
import script from "./image-capture.vue?vue&type=script&lang=js&"
export * from "./image-capture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd98a7a4",
  null
  
)

export default component.exports